<template>
    <div class="input-textbox">
        <b-form-group  :id="groupId" v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <b-input-group class="input-text">
                    <b-input-group-prepend is-text v-if="prefixExist">
                        {{ prefix }}
                    </b-input-group-prepend>
                    <b-form-input :ref="'ref-input-' + id" v-bind="$attrs" v-model="inputModel" :formatter="inputFormatter" :lazy-formatter="true" :type="type" @input="inputFocus" @blur="inputUpdate" :maxlength="maxLength" @keyup.enter="enterAction" @keyup="keyupAction" @focus="onFocusAction"></b-form-input>
                    <b-input-group-append is-text v-if="suffixExist">
                        {{ suffix }}
                    </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback :id="feedbackId" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="(useLabel ? 'input-label-detail' : '') + (this.thousandSeparator ? ' input-label-currency' : '')" v-else-if="isUpdatable">
                <span v-if="this.thousandSeparator">
                    <app-currency-label :text="inputModel != null && inputModel != '' ? inputModel : '-'" />
                    <span class="float-right ml-2"><a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
                </span>
                <span v-else>
                    <span>{{ inputModel != null && inputModel != "" ? inputModel : "-" }}</span>
                    <span class="float-right"><a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
                </span>
                
            </div>
            <div :class="(this.thousandSeparator ? ' input-label-detail' : '')" v-else>
                <span v-if="this.thousandSeparator">
                    <app-currency-label :text="inputModel" />
                </span>
                <span v-else>
                    {{ inputModel }}
                </span>
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-input-group>
                <b-input-group-prepend is-text v-if="prefixExist">
                    {{ prefix }}
                </b-input-group-prepend>
                <b-form-input v-bind="$attrs" v-model="popoverInputModel" :formatter="inputFormatter" :lazy-formatter="true" :type="type" @input="inputFocus" :maxlength="maxLength" @keyup.enter="enterAction" @keyup="keyupAction" @focus="onFocusAction"></b-form-input>
                <b-input-group-append is-text v-if="suffixExist">
                    {{ suffix }}
                </b-input-group-append>
            </b-input-group>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="inputUpdate" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<style lang="scss" scoped>
.input-textbox{
    .input-label-detail {
        line-height: 1.3 !important;
        height: max-content;
    }
}
</style>
<script>
export default {
    props: ["model", "id", "name", "errorMessage", "suffix", "prefix", "state", "maxLength", "thousandSeparator", "decimalSeparator", "isEditable", "isUpdatable", "change", "label", "isRequired", "enterMethod", "type","nolabel","keyupMethod","isFocus"],
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            groupId : "fieldset-" + this.id,
            feedbackId : "input-" + this.id + "-live-feedback",
            popoverShow: false,
            popoverInputModel: this.model,
        }
    }, 
    methods: {
        inputUpdate() {
            if (this.thousandSeparator || this.decimalSeparator) {
                if (this.inputModel != null && this.inputModel != "" && this.inputModel != undefined)
                    this.inputModel = this.inputModel.replace(/,/g, "");
            }
            
            if (this.isUpdatable) {
                this.inputModel = this.popoverInputModel;
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
                this.popoverShow = false;
            } else {
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
            }
        },
        inputFocus() {
            if (this.thousandSeparator) {
                if (this.inputModel != null && this.inputModel != "" && this.inputModel != undefined) {
                    this.inputModel = this.inputModel.replace(/^0+/, '');
                    this.inputModel = this.inputModel.replace(/,/g, "");
                }
            }

            if (this.decimalSeparator) {
                if (this.inputModel != null && this.inputModel != "" && this.inputModel != undefined) {
                    this.inputModel = this.inputModel.replace(/^00|^0(?=[^0.,])/g, '');
                    this.inputModel = this.inputModel.replace(/,/g, "");
                } 
            }
        },
        onFocusAction() {
            if (this.thousandSeparator) {
                if (this.inputModel != null && this.inputModel != "" && this.inputModel != undefined) {
                    this.inputModel = this.inputModel.replace(/^0+/, '');
                }
            }

            if (this.decimalSeparator) {
                if (this.inputModel != null && this.inputModel != "" && this.inputModel != undefined) {
                    this.inputModel = this.inputModel.replace(/^00|^0(?=[^0.,])/g, '');
                } 
            }
        },
        enterAction() {
            this.$emit('update:model', this.inputModel);
            this.$emit('enterMethod')
        },
        keyupAction() {
            this.$emit('update:model', this.inputModel);
            this.$emit('keyupMethod')
        },
        inputFormatter(value) {
            if (this.thousandSeparator) {
                if (value != null && value != "" && value != undefined)
                    return value
                        .replace(/[^\d.-]/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return "0";
            }else if (this.decimalSeparator) {
                if (value != null && value != "" && value != undefined)
                {
                    if(value.toString().includes('.')) {
                        value = value
                        .replace(/[^0-9.]/g, '')
                        .replace(/,/g, '')
                        .replace(/\.{3,}/g, '.');
                        let dotIndex = value.indexOf('.');
                        if (dotIndex !== -1) {
                            let beforeDot = value.slice(0, dotIndex + 1);
                            let afterDot = value.slice(dotIndex + 1).replace(/\./g, '');
                            return beforeDot + afterDot;
                        } else {
                            return value;
                        }
                    } else {
                        return value
                        .replace(/[^\d.-]/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                }
                return "0";
            } 
            return value;
        },
        onPopoverShow() {
            this.popoverInputModel = this.inputModel;
            this.popoverShow = true;
        },
        setFocusOnInput() {
            setTimeout(async () => {
                await this.$nextTick( async() => {
                    if (this.$refs["ref-input-" + this.id]) {
                        await this.$refs["ref-input-" + this.id].focus();
                    }
                });
            },50);
        }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch : {
        model : function(val) {
            this.inputModel = val;
            if((this.thousandSeparator || this.decimalSeparator) && val != undefined && val != null) {
                this.inputModel = this.inputFormatter(val.toString());
            }
        },
        label : function(val) {
            this.labelStr = val;
        },
        isFocus : function (newValue,oldValue) {
            if(newValue){
                this.$nextTick(() => {
                    this.setFocusOnInput();
                });
            }
        }
    },
	beforeMount() {
		if((this.thousandSeparator || this.decimalSeparator) && this.model != undefined && this.model != null) {
            console.log('value',this.model.toString());

            this.inputModel = this.inputFormatter(this.model.toString());
        }
	},
    
	mounted(){
		// this.inputModel = this.inputFormatter(this.model.toString());
        if (this.isFocus) {
            this.setFocusOnInput();
        }
	},
}
</script>
<style scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
</style>